import { render } from "./FormHandleRegister.vue?vue&type=template&id=0cb1ecc7&scoped=true&ts=true"
import script from "./FormHandleRegister.vue?vue&type=script&lang=ts"
export * from "./FormHandleRegister.vue?vue&type=script&lang=ts"

import "./FormHandleRegister.vue?vue&type=style&index=0&id=0cb1ecc7&scoped=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb1ecc7"]])

export default __exports__